import { AxiosResponse } from "axios";

import { API } from "../index";

export type FreeSeatPackage = {
  id: number;
  name?: string;
  "상품명"?: string;
  has_spots?: boolean;
  count?: number;
  max_personnel_day?: number | null;
  spots?: Array<{ id: number; name: string; is_able?: boolean; is_free?: boolean }>;
};

export type FreeSeatAssignedSeat = {
  id: number;
  name: string;
};

export type FreeSeatBoardReservation = {
  id: number;
  customer_name: string;
  phone: string;
  start_date: string;
  end_date: string;
  state: string;
  order_state: string;
  assigned_seat: FreeSeatAssignedSeat | null;
};

export type FreeSeatBoardSeat = {
  id: number;
  package: number;
  name: string;
  display_order: number;
  is_active: boolean;
  x: number;
  y: number;
  width: number;
  height: number;
  rotation: number;
  meta?: Record<string, any> | null;
  assigned_reservation: FreeSeatBoardReservation | null;
};

export type FreeSeatBoard = {
  package: {
    id: number;
    name: string;
    capacity: number;
  };
  layout: {
    package: number;
    canvas_width: number;
    canvas_height: number;
    background_image_url: string;
    updated_at: string | null;
  };
  seats: FreeSeatBoardSeat[];
  reservations: FreeSeatBoardReservation[];
};

export type FreeSeatLayoutPayload = {
  package: number;
  layout: {
    canvas_width: number;
    canvas_height: number;
    background_image_url: string;
  };
  seats: Array<{
    id: number;
    x: number;
    y: number;
    width: number;
    height: number;
    rotation: number;
    display_order: number;
    meta?: Record<string, any> | null;
  }>;
};

const getPackageName = (item: FreeSeatPackage) => item.name || item["상품명"] || `상품 ${item.id}`;

export const freeSeatAssignmentService = {
  async listFreeSeatPackages(): Promise<FreeSeatPackage[]> {
    const response: AxiosResponse<FreeSeatPackage[]> = await API.get("/package/items/?include_hidden=true");
    return (response.data || [])
      .filter((item) => item.has_spots === false)
      .map((item) => ({
        ...item,
        name: getPackageName(item),
      }));
  },

  async getBoard(packageId: number, date: string): Promise<FreeSeatBoard> {
    const response: AxiosResponse<FreeSeatBoard> = await API.get("/api/v2/free-seat-assignment-board/", {
      params: { package: packageId, date },
    });
    return response.data;
  },

  async saveLayout(payload: FreeSeatLayoutPayload): Promise<Pick<FreeSeatBoard, "package" | "layout" | "seats">> {
    const response: AxiosResponse<Pick<FreeSeatBoard, "package" | "layout" | "seats">> = await API.patch(
      "/api/v2/free-seat-assignment-board/layout/",
      payload,
    );
    return response.data;
  },
};
